import { DatePipe } from '@angular/common';
import { LowerCasePipe } from '../../filters/lower-case.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemInfoPopoverComponent } from '../../components/item-info-popover/item-info-popover.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { PreVisitThankYouComponentComponent } from '../../components/pre-visit/thank-you/pre-visit-thank-you.component';
import { Component, OnInit, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import RestService from '../../services/core-rest.service';
import Session from '../../utils/session.service';
import UserService from '../../services/user.service';
import PreVisitRecordTicketForPersonService from '../../services/pre-visit-record-ticket-for-person.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import RoutingService from '../../services/routing.service';

@Component({
	standalone: true,
	selector: 'prescription-list',
	templateUrl: './prescription-list.component.html',
	imports: [
		CommonModule, DatePipe, LowerCasePipe, TranslatePipe,
		ItemInfoPopoverComponent, LoaderOverlayComponent, 
		PreVisitThankYouComponentComponent, FormsModule, RouterLink
	]
})
export default class PrescriptionListComponent implements OnInit, OnDestroy {
	private restService: RestService = inject(RestService);
	private session: Session = inject(Session);
	private userService: UserService = inject(UserService);
	private preVisitRecordTicketForPersonService: PreVisitRecordTicketForPersonService = inject(PreVisitRecordTicketForPersonService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('prescriptionList').then(() => {
			this.restService.getPreVisitTicketConfig({ 'parentCategory': 'CHRONICALLY_ILL_PRESCRIPTION_REQUEST' })
				.then((parentCategoryConfig) => {
					this.vm.parentCategoryConfig = parentCategoryConfig;
					this.onResolve();
				});
		});
	}
	
	onResolve() {
		this.vm.loading = true;
		this.vm.isRecordTicketForPerson = false;
		this.vm.showFreeInputSection = false;
		this.vm.thankYouInformationSection = "<p>"
			+ this.angularFilterHelperService.translate('PreVisit.Prescription_Checkout.Application_Forwarded')
			+ "</p>"
			+ "<p>"
			+ this.angularFilterHelperService.translate('PreVisit.Symptom_Check_Results.Contacted_In_Level_1')
			+ "</p>";
		
		this.vm.user = this.session.getSession().user;
		this.vm.pageSize = this.vm.pageSize || 10;
		this.vm.currentPage = this.vm.currentPage || 0;
		this.vm.params = this.angularRoutingHelperService.getQueryParams() || {};
		this.vm.xRoadProblems = false;
		this.vm.showRenewablePrescriptions = false;
		this.vm.prescriptionCreatedStatusCode = '00';
		this.vm.isPreVisit = this.vm.params['type'] === 'pre-visit';
		this.vm.thirdPartyRenewal = window.sessionStorage.getItem("THIRD_PARTY_RENEWAL");
		this.vm.showOnlyThankYouSection = false;
		this.vm.isRecordTicketForPerson = !!this.preVisitRecordTicketForPersonService.getPatient();
		this.vm.patientNoteForDoctor = '';
		this.vm.otherDescriptionConf = this.vm.parentCategoryConfig.filter((item) => {
			return item.fieldName === "OTHER_DESCRIPTION"
		})[0];
		this.vm.otherDescriptionConfLabel = (this.vm.otherDescriptionConf && this.vm.otherDescriptionConf.label)
			? this.angularHelperService.trustAsHtml(this.vm.otherDescriptionConf.label)
			: '';
		
		this.vm.selectedPrescriptionIds = {};
		
		if (this.preVisitRecordTicketForPersonService.getPatient()) {
			var patientUserId = this.preVisitRecordTicketForPersonService.getPatient().user.id;
			this.restService.getPreVisitRecordForPatientUserPrescriptions({ userId: patientUserId })
				.then((response) => {
					this.vm.prescriptions = response;
					this.userService.setEhifPrescriptions(response);
					this.vm.loading = false;
				})
				.catch((error) => {
					console.log(error);
					if (error.error.errorCode === 'CONSENT_NOT_GIVEN_TO_PRESCRIPTION_DATA') {
						var newObject: any = (this.vm.params ? Object.assign({}, this.vm.params) : {});
						newObject['comingFrom'] = 'prescription-list';
						this.angularRoutingHelperService.setPath('/xroad/consents', false, false, newObject);
					}
				});
		} else {
			this.restService.getUserPrescriptionsDetailed({ isPreVisit: this.vm.isPreVisit })
				.then((response) => {
					this.vm.prescriptions = response;
					this.userService.setEhifPrescriptions(response);
					this.vm.loading = false;
				})
				.catch((error) => {
					console.log(error);
					if (error.error.errorCode === 'CONSENT_NOT_GIVEN_TO_PRESCRIPTION_DATA') {
						var newObject: any = (this.vm.params ? Object.assign({}, this.vm.params) : {});
						newObject['comingFrom'] = 'prescription-list';
						this.angularRoutingHelperService.setPath('/xroad/consents', false, false, newObject);
					} else if (error.error.errorCode === 'XROAD_CONSENT_NOT_GIVEN_TO_PRESCRIPTION_DATA') {
						this.angularRoutingHelperService.setPath('/xroad/consent-service', false, false,
							{ comingFrom: this.getXRoadConsentCallbackTarget() });
					} else if (error.error.errorCode === 'NO_MISP_SESSION') {
						this.angularRoutingHelperService.setPath('/pre-visit/record-ticket-for-person');
					} else if (error.error.errorCode === 'ERROR_XROAD_CONSENTS_ACCESS_FOR_MINOR') {
						this.vm.loading = false;
						this.vm.xRoadProblems = true;
						this.vm.xRoadErrorMessage = this.angularFilterHelperService.translate('XRoadConsentService.Error_Minor');
					} else if (error.error.errorCode === 'ERROR_WHILE_CHECKING_XROAD_CONSENTS') {
						this.vm.loading = false;
						this.vm.xRoadProblems = true;
						this.vm.xRoadErrorMessage = this.angularFilterHelperService.translate('PreVisit.Prescription_List.X_Road_Problems');
					}
				});
		}
		
		this.vm.disclaimers = {
			'CANCELED': this.angularFilterHelperService.translate('Booking.Prescription.Disclaimer_Canceled'),
			'DISABLED': this.angularFilterHelperService.translate('Booking.Prescription.Disclaimer_Disabled'),
			'ANTIBACTERIAL': this.angularFilterHelperService.translate('Booking.Prescription.Disclaimer_Antibacterial'),
			'ANTIFUNGAL': this.angularFilterHelperService.translate('Booking.Prescription.Disclaimer_Antifungal'),
			'ANTIVIRAL': this.angularFilterHelperService.translate('Booking.Prescription.Disclaimer_Antiviral'),
			'PSYCHOTROPIC': this.angularFilterHelperService.translate('Booking.Prescription.Disclaimer_Psychotropic')
		};
		this.vm.prescriptionStatusByCode = {
			'00': this.angularFilterHelperService.translate('PreVisit.Prescription_List.Prescription_Status.Created'),
			'10': this.angularFilterHelperService.translate('PreVisit.Prescription_List.Prescription_Status.Sold'),
			'20': this.angularFilterHelperService.translate('PreVisit.Prescription_List.Prescription_Status.Booked_By_Pharmacy'),
			'30': this.angularFilterHelperService.translate('PreVisit.Prescription_List.Prescription_Status.Booked_By_Operator'),
			'99': this.angularFilterHelperService.translate('PreVisit.Prescription_List.Prescription_Status.Cancelled')
		};
		
		this.vm.generatePrescriptionExtendLink = this.generatePrescriptionExtendLink;
		this.vm.getDisclaimerTextForDisabled = this.getDisclaimerTextForDisabled;
		this.vm.submitPreVisitPrescriptionRenewal = this.submitPreVisitPrescriptionRenewal;
	};
	
	ngOnDestroy() {
		
	}
	
	getXRoadConsentCallbackTarget() {
		if (this.vm.isPreVisit) {
			return "pre-visit";
		} else {
			return 'prescription-list';
		}
	}
	
	getDisclaimerTextForDisabled(prescription) {
		var canceledPrescriptionStatusCode: any = "99";
		if (prescription.statusCode === canceledPrescriptionStatusCode) {
			return this.vm.disclaimers['CANCELED'];
		}
		var drugIngredient: any = prescription.drugIngredient;
		var isDisabled: any = drugIngredient && !drugIngredient.enabled;
		var notAllowedTypes: Array<any> = ['ANTIBACTERIAL', 'ANTIFUNGAL', 'ANTIVIRAL', 'PSYCHOTROPIC'];
		if (isDisabled && drugIngredient.type && notAllowedTypes.includes(drugIngredient.type)) {
			return this.vm.disclaimers[drugIngredient.type]
		} else {
			return this.vm.disclaimers['DISABLED'];
		}
	}
	
	generatePrescriptionExtendLink(prescription) {
		var newParams: any = { pNr: prescription.prescriptionNumber };
		if (this.vm.params['origin']) {
			newParams['origin'] = this.vm.params['origin'];
		}
		if (this.vm.params['type']) {
			newParams['type'] = this.vm.params['type'];
		}
		return newParams;
	}
	
	submitPreVisitPrescriptionRenewal() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		if (this.vm.isSaving || Object.values(this.vm.selectedPrescriptionIds).length === 0) {
			return;
		}
		
		var ticketServiceRequestOptions: Array<any> = [];
		var groupedByOverride: any = 1;
		for (var selectedPrescriptionNr in this.vm.selectedPrescriptionIds) {
			for (var index in this.vm.prescriptions) {
				var prescription: any = this.vm.prescriptions[index];
				if (prescription.prescriptionNumber == selectedPrescriptionNr
						&& this.vm.selectedPrescriptionIds[selectedPrescriptionNr]) {
					for (var objConf in this.vm.parentCategoryConfig) {
						var conf: any = Object.assign({}, this.vm.parentCategoryConfig[objConf]);
						if (conf.fieldName === 'ATC_CODE') {
							conf.content = prescription.atcCode;
						} else if (conf.fieldName === 'ATC_NAME') {
							conf.content = prescription.atcName;
						} else if (conf.fieldName === 'ESTONIAN_PRESCRIPTION_NUMBER') {
							conf.content = prescription.prescriptionNumber;
						} else if (conf.fieldName === 'OTHER_DESCRIPTION') {
							conf.content = this.vm.patientNoteForDoctor;
						}
						if (conf.content) {
							conf.groupedBy = groupedByOverride;
							ticketServiceRequestOptions.push(conf)
						}
					}
					groupedByOverride++;
				}
			}
		}
		var submitData: any = {
			"type": 'CHRONICALLY_ILL_PRESCRIPTION_REQUEST',
			"selectedServiceRequestDetails": ticketServiceRequestOptions
		}
		submitData = this.preVisitRecordTicketForPersonService.addRecordTicketForPersonData(submitData);
		this.vm.isSaving = true;
		this.restService.savePreVisitNewGeneralServiceRequest(submitData)
			.then((response) => {
				this.vm.showFreeInputSection = false;
				this.vm.preVisitTicketId = response.id
				this.vm.showOnlyThankYouSection = true;
				this.vm.isSaving = false;
				deferred.resolve();
			})
			.catch((error) => {
				deferred.reject(error);
				this.vm.isSaving = false;
				console.log(error);
			});
		
		return deferred.promise;
	}
	
}